/** Build a stable, URL-safe slug from an artist + song title.
 * Used by the share flow so links always resolve to the same song even if
 * the slot's rank changes after an admin reorder.
 *
 *   slugify("Almight E", "Arch City Anthem") → "almight-e--arch-city-anthem"
 */
export function slugify(...parts) {
  return parts
    .filter(Boolean)
    .map((s) => String(s)
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-+|-+$)/g, "")
    )
    .filter(Boolean)
    .join("--");
}

/** Find a slot from the given list whose slug matches the URL slug.
 * Falls back to rank-match when slug is absent or no match found. */
export function findSlotForDeeplink(slots, rank, slug) {
  if (slug) {
    const want = slug.toLowerCase();
    const bySlug = slots.find((s) => slugify(s.artist_name, s.song_title) === want);
    if (bySlug) return bySlug;
  }
  const r = parseInt(rank, 10);
  if (Number.isFinite(r)) {
    const byRank = slots.find((s) => s.rank === r);
    if (byRank) return byRank;
  }
  return null;
}
